/*首页国搜头条添加链接地址*/
// function isTabNav(){
// 	var qieHuanNavcur = $(".qieHuanNav li:last").hasClass('cur');
// 	if(qieHuanNavcur){
// 		$(".qieHuanNav .cur a").attr("href","http://toutiao.chinaso.com" ); 
// 		$(".qieHuanNav .cur a").attr("target","_blank"); 
// 	}else{
// 		$(".qieHuanNav li").eq(2).find("a").attr("href","javascript:;" ); 
// 		$(".qieHuanNav li").eq(2).find("a").removeAttr("target","_blank"); 
// 	}	
// }

// isTabNav();


/**
 * tab 标签切换
 * jQuery 插件方式
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node, CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // 浏览器全局变量(root 即 window)
        root.returnExports = factory(root.jQuery);
    }
}(this, function ($) {
  var jQuery = $;
  function itemConvert (setting) {
    var T = this;
    T.defaults = {

      // 容器定义
      container: "body",

      // tab标签定义
      item: "",

      // 切换内容定义
      content: "",

      // 设置当前标签样式
      cur: "",

      // 是否自动播放
      isAutoPlay: !1,

      // 自动播放速度
      autoSpeed: 100000,

      // 切换延迟
      hoverSpeed: 200,

      //  触发事件定义
      events: "",

      // 切换完成后回调
      callback: function() {},
      preCallback: function () {},

      // 是否关闭触发切换功能
      isClose: false
    };
    T.defaults = jQuery.extend(T.defaults, setting);
    T.container = T.defaults.container;
    T.$item = T.defaults.item;
    if (typeof T.defaults.item === 'string') {
      T.$item = jQuery(T.container + " " + T.defaults.item);
    }
    if(T.defaults.events && T.defaults.events == "click"){
      T.$item.on({
        click: function () {
          var $cur = jQuery(this);
          clearTimeout(T.tabClearTimeId);
          // isTabNav();
          //首页国搜头条添加链接地址
          if (T.defaults.isClose) {
            return false;
          }
          // T.tabClearTimeId = setTimeout(function () {
            T.convert($cur);
          // }, 100);
        }
      });
    } else {
      T.$item.on({
        mouseover: function () {
          var $cur = jQuery(this);
          clearTimeout(T.tabClearTimeId);
          clearTimeout(T.autoPlayClearId);
          if (T.defaults.isClose) {
            return false;
          }
          T.tabClearTimeId = setTimeout(function () {
            T.convert($cur);
          }, T.defaults.hoverSpeed);
        },
        mouseout: function () {
          clearTimeout(T.tabClearTimeId);
          clearTimeout(T.autoPlayClearId);
          T.autoPlay();
        }
      });
    }
    if (T.defaults.isAutoPlay) {
      $(T.container).on({
        mouseover: function () {
          clearTimeout(T.autoPlayClearId);
        },
        mouseout: function () {
          clearTimeout(T.autoPlayClearId);
          T.autoPlay();
        }
      });
    }
    T.initialize();
  }

  jQuery.extend(itemConvert.prototype, {
    initialize: function () {
      var T = this;
      if (T.defaults.num || T.defaults.num === 0) {
        T.convert();
      }
      T.autoPlay();
    },
    convert: function ($cur) {
      var T = this,
        itemIndex;
      T.defaults.preCallback(itemIndex);
      $cur = $cur || T.$item.eq(0);
      itemIndex = $cur.index(T.$item.selector);
      $cur.addClass(T.defaults.cur).siblings().removeClass(T.defaults.cur);
      $cur.parents(T.container).find(T.defaults.content)
        .eq(itemIndex).show().siblings(T.defaults.content).hide();
      T.defaults.callback(itemIndex);
    },
    autoPlay: function () {
      var T = this,
        $cur;
      if (T.defaults.isAutoPlay && T.defaults.events !== "click") {
        $cur = $(T.defaults.container).find("." + T.defaults.cur).next();
        if (!$cur.length) {
          $cur = T.$item.eq(0);
        }
        clearTimeout(T.autoPlayClearId);
        T.autoPlayClearId = setTimeout(function () {
          T.convert($cur);
          T.autoPlay();
        }, T.defaults.autoSpeed);
      }
    }
  });
  return itemConvert;
}));



//////////////////
// WEBPACK FOOTER
// ./static/v4/js/item_convert.js
// module id = 177d64c9623a51d97172
// module chunks = 1